import { render, staticRenderFns } from "./ClientPhones.vue?vue&type=template&id=e96ce460&scoped=true"
import script from "./ClientPhones.vue?vue&type=script&lang=js"
export * from "./ClientPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96ce460",
  null
  
)

export default component.exports